export default "__VITE_ASSET__Ctl9YV6f__"